// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import axios from 'axios';
import QueryString from 'qs';
import {
  setupAuthInterceptor,
  useAuthTokenInterceptor,
  getAuthStateLazy,
} from './auth0';
import { trackPromise } from 'react-promise-tracker';
import { RTK_PROMISE_TRACKER_ID } from '@shared/data-access/utils/constants';
import { environment } from '@shared/environment';

const baseURL = environment.API.BROKER_BASE_URL;

type FetchDataFuncProps = {
  endpoint: string;
  method: 'GET' | 'POST' | 'DELETE' | 'PATCH';
  payload?: any;
  params?: any;
  signal?: AbortSignal;
  useTrackPromise?: boolean;
};

export const brokerApi = setupAuthInterceptor(
  axios.create({
    baseURL,
    headers: {
      'Content-Type': environment.API_CONSTANTS.HEADERS.CONTENT_TYPE,
      accept: environment.API_CONSTANTS.HEADERS.ACCEPT,
    },
    timeout: environment.API_CONSTANTS.TIMEOUT_MS,
    paramsSerializer(params) {
      return QueryString.stringify(params, { encode: false });
    },
  }),
  getAuthStateLazy,
  useAuthTokenInterceptor,
);

export const fetchBrokerageApi = <T>({
  method,
  endpoint,
  payload,
  params,
  signal,
  useTrackPromise,
}: FetchDataFuncProps) => {
  return useTrackPromise
    ? trackPromise(
        brokerApi.request<T>({
          method,
          url: endpoint,
          data: payload,
          params,
          signal,
        }),
        RTK_PROMISE_TRACKER_ID,
      )
    : brokerApi.request<T>({
        method,
        url: endpoint,
        data: payload,
        params,
        signal,
      });
};
